<app-subpage-header [title]="title" size="small"></app-subpage-header>
<ng-container *ngIf="recentlyViewedItems && recentlyViewedItems?.length > 0; else noRecentlyViewed">
    <ul class="recently-viewed">
        <li
            class="recently-viewed-item"
            *ngFor="let recentlyViewedItem of recentlyViewedItems | slice: 0 : 5; trackBy: trackByItem">
            <span>
                <mat-icon [svgIcon]="'rewind_clock'" aria-hidden></mat-icon>
            </span>
            <h6 class="ellipsis-2">
                <a
                    class="no-underline"
                    [title]="recentlyViewedItem?.title"
                    aria-haspopup="dialog"
                    (click)="handleOpenDialog(recentlyViewedItem.title)"
                    [attr.data-analytics]="getAnalyticsData(recentlyViewedItem?.title)">
                    {{ recentlyViewedItem?.title }}
                </a>
            </h6>
        </li>
    </ul>
</ng-container>

<ng-template #noRecentlyViewed>
    <div class="no-queries-message"> You currently have no recently viewed content to display. </div>
</ng-template>
